import { render, staticRenderFns } from "./ContactSettings.vue?vue&type=template&id=7e4f3623"
import script from "./ContactSettings.vue?vue&type=script&lang=ts"
export * from "./ContactSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e4f3623')) {
      api.createRecord('7e4f3623', component.options)
    } else {
      api.reload('7e4f3623', component.options)
    }
    module.hot.accept("./ContactSettings.vue?vue&type=template&id=7e4f3623", function () {
      api.rerender('7e4f3623', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/default/ContactSettings.vue"
export default component.exports